export const FETCH_TICKETS = "FETCH_TICKETS";
export const ADD_TICKETS = "ADD_TICKETS";
export const FETCH_TICKET_MESSAGES = "FETCH_TICKET_MESSAGES";
export const SEND_TICKET_MESSAGE = "SEND_TICKET_MESSAGE";
export const FETCH_TICKET_DETAIL = "FETCH_TICKET_DETAIL";
export const SEND_TICKET_DOCUMENTS = "SEND_TICKET_DOCUMENT";
export const FETCH_TICKET_DOCUMENTS = "FETCH_TICKET_DOCUMENTS";
export const DOWNLOAD_TICKET_DOCUMENT = "DOWNLOAD_TICKET_DOCUMENT";
